export default "__VITE_ASSET__1254b5fc__"